import {msg} from "@lingui/macro";
import {i18n} from "@lingui/core";

export const REQUIRED_FIELD = {required: i18n._(msg`This field is required.`)};
